import { corpusForTargetMonthlySWP, requiredSIPForTarget } from "../../engine/calculations";

const config = {
  key: "req-sip-for-swp",
  title: "SIP Required For Target Monthly SWP",
  category: "Target-Based",
  description: "Find the monthly SIP you need today so you can later draw a fixed monthly income for years.",
  fields: [
    { key: "monthlyWithdrawal", label: "Target monthly withdrawal", type: "currency", default: 50_000, min: 500, max: 50_00_000 },
    { key: "withdrawYears", label: "Years the income should last", type: "number", default: 20, min: 1, max: 50 },
    { key: "withdrawReturn", label: "Return during withdrawal", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
    { key: "buildYears", label: "Years you'll invest before that", type: "number", default: 15, min: 1, max: 40 },
    { key: "buildReturn", label: "Return while building the corpus", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  compute(values) {
    const monthlyWithdrawal = Number(values.monthlyWithdrawal) || 0;
    const withdrawYears = Number(values.withdrawYears) || 0;
    const withdrawReturn = (Number(values.withdrawReturn) || 0) / 100;
    const buildYears = Number(values.buildYears) || 0;
    const buildReturn = (Number(values.buildReturn) || 0) / 100;

    const corpusNeeded = corpusForTargetMonthlySWP(monthlyWithdrawal, withdrawReturn, withdrawYears);
    const requiredMonthlySIP = requiredSIPForTarget(corpusNeeded, buildReturn, buildYears * 12);

    return {
      headline: { label: "Required Monthly SIP", value: requiredMonthlySIP },
      extraHeadlines: [{ label: "Corpus needed at the end of the build period", value: corpusNeeded }],
      breakdown: [{ label: "Target monthly withdrawal", value: monthlyWithdrawal }],
    };
  },
};

export default config;
